import { HttpService, ProfilesProvider, ProfilesService } from "@sportal/api";
import { SC_CODE } from "./appConfigService";

export const makeProfilesService = (
  http: HttpService,
  baseUrl: string
): ProfilesService =>
  new ProfilesService(new ProfilesProvider(http, baseUrl, SC_CODE));
